import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

try {
    console.log('Initializing Datadog RUM...');
    datadogRum.init({
        applicationId: '158538d0-8379-4936-aa2c-23cab0240f04',
        clientToken: 'pubc92c2803f2360d273d4a1b1820dc21cf',
        site: 'us5.datadoghq.com',
        service: 'cloud-image-investigator-frontend',
        env: 'cavm',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackViewsManually: false,
        plugins: [reactPlugin({ router: false })],
    });
    
    // Set user information for analytics
    datadogRum.setUser({
        id: 'anonymous', // You can set this to a real user ID when available
        name: 'Anonymous User', // You can set this to a real username when available
        email: 'anonymous@example.com', // You can set this to a real email when available
    });
    
    // Add global context for better analytics
    datadogRum.addAction('app_loaded', {
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
    });
    
    console.log('Datadog RUM initialized successfully');
} catch (error) {
    console.error('Failed to initialize Datadog RUM:', error);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
